import { AppState } from '../bootstrap';

export class MessageFormAppState extends AppState {
  getState() {
    // NOTE. Don't call super.getState(); on the models that coexist
    // with other models on the same page. In that case each model
    // will receive whole JSON payload from backend
    this.config = this.raw_data.config;
    this.member = this.raw_data.member;
    this.product = this.raw_data.product;
    this.url = this.raw_data.messageFormData.endpoint;
    this.user = this.raw_data.messageFormData.user;
    this.signedProduct = this.raw_data.messageFormData.signedProduct;
    this.ratingAmount = this.raw_data.messageFormData.ratingAmount;
    this.form = {
      errors: {},
      body: '',
    };
    this.isModalOpen = false;
    this.isSubmitting = false;

    return this;
  }
}

export class ToggleFavouriteButtonAppState extends AppState {
  getState() {
    // NOTE. Don't call super.getState(); on the models that coexist
    // with other models on the same page. In that case each model
    // will receive whole JSON payload from backend
    this.config = this.raw_data.config;
    this.member = this.raw_data.member;
    this.product = this.raw_data.product;
    this.favouriteUrl = this.raw_data.toggleFavouriteButtonData.url;
    this.isActive = this.raw_data.toggleFavouriteButtonData.isActive;
    this.starred_times = this.raw_data.toggleFavouriteButtonData.starred_times;
    this.scope = null;
    this.isSubmitting = false;
    return this;
  }
}
